// Extract value from ApplicantCustomFieldValue based on field type
export const getValueForFieldType = (fieldType, valueRecord) => {
  if (!valueRecord) return null

  switch (fieldType) {
    case 'STRING':
      return valueRecord.stringValue
    case 'BOOLEAN':
      return valueRecord.booleanValue
    case 'DATE':
      return valueRecord.dateValue
    case 'SINGLE_SELECT':
    case 'MULTI_SELECT':
      return valueRecord.selectValues
    default:
      return null
  }
}

// Build mutation input from field type and value
export const buildInputForFieldType = (
  fieldType,
  applicantId,
  customFieldId,
  value
) => {
  const input: any = { applicantId, customFieldId }

  switch (fieldType) {
    case 'STRING':
      input.stringValue = value
      break
    case 'BOOLEAN':
      input.booleanValue = value
      break
    case 'DATE':
      input.dateValue = value
      break
    case 'SINGLE_SELECT':
    case 'MULTI_SELECT':
      input.selectValues = value
      break
  }

  return input
}

// Format value for read-only display
export const formatValueForDisplay = (field, valueRecord) => {
  if (!valueRecord) return '—'

  const value = getValueForFieldType(field.fieldType, valueRecord)

  if (value === null || value === undefined) return '—'

  switch (field.fieldType) {
    case 'STRING':
      return value
    case 'BOOLEAN':
      return value ? 'Yes' : 'No'
    case 'DATE':
      return new Date(value).toLocaleDateString()
    case 'SINGLE_SELECT': {
      if (!value || !Array.isArray(value) || value.length === 0) return '—'
      const option = field.options?.find((opt) => opt.value === value[0])
      return option?.label ?? value[0] ?? '—'
    }
    case 'MULTI_SELECT':
      if (!value || value.length === 0) return '—'
      return value
        .map((v) => {
          const opt = field.options?.find((o) => o.value === v)
          return opt?.label || v
        })
        .join(', ')
    default:
      return '—'
  }
}
